import Swiper, {
    Autoplay,
    Navigation,
    Lazy,
    Pagination,
    EffectFade,
    EffectCube,
    EffectFlip,
    EffectCoverflow,
    Parallax,
    Thumbs
} from 'swiper';

Swiper.use([Autoplay, Navigation, Lazy, Pagination, EffectFade, EffectCube, EffectFlip, EffectCoverflow, Parallax, Thumbs]);

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

let curVideo;
let lastVideo;
let mySwiper;
let thumbSwiper;
let myThumbs;
let myNavi;
let myId

const allSwiper = {
    setSwiper: function() {
        const swiperTarget = document.querySelectorAll('.swiper-container');

        Array.from(swiperTarget).forEach((element, index, array) => {
            myId = element.getAttribute('data-id');
            myNavi = element.getAttribute('data-navi');
            thumbSwiper = document.getElementById(element.getAttribute('data-thumbs')) || false;

            if(thumbSwiper) {
                myThumbs = new Swiper(thumbSwiper, {
                    spaceBetween: 10,
                    slidesPerView: 3,
                    freeMode: true,
                    loop: false,
                    watchSlidesProgress: true,
                });
            }

            mySwiper = new Swiper('#' + myId, {
                autoHeight: element.getAttribute('data-autoheight') || false,

                slidesPerView: element.getAttribute('data-slides-desktop') || 1,

                // parallax: {
                //     enabled: true
                // },

                effect: element.getAttribute('data-animation') || 'slide',

                mode: 'horizontal',

                // preloadImages: false,

                // lazy: true,

                // navigation: false,

                fadeEffect: {
                    crossFade: true
                },

                flipEffect: {
                    slideShadows: false,
                },

                cubeEffect: {
                    slideShadows: false,
                },

                coverflowEffect: {
                    rotate: 30,
                    slideShadows: false,
                },

                navigation: {
                    nextEl: '.swiper-next.' + myNavi,
                    prevEl: '.swiper-prev.' + myNavi,
                },

                loop: element.getAttribute('data-loop') || false,

                autoplay: element.getAttribute('data-autoplay') ? {
                    delay: parseInt(element.getAttribute('data-delay')) || false,
                    disableOnInteraction: true,
                    pauseOnMouseEnter: true
                } : false,

                speed: parseInt(element.getAttribute('data-speed')) || 1000,

                pagination: element.getAttribute('data-pagination') === 'true' ? {
                    clickable: true,
                    el: '.swiper-pagination.' + myNavi,
                    type: 'bullets',
                } : false,

                thumbs: {
                    swiper: thumbSwiper ? myThumbs : false,
                },

                breakpoints: element.getAttribute('data-breakpoints') === 'true' ? {

                    1280: {
                        slidesPerView: element.getAttribute('data-slides-desktop') || 1
                    },

                    768: {
                        slidesPerView: element.getAttribute('data-slides-tablet') || 1
                    },

                    680: {
                        slidesPerView: element.getAttribute('data-slides-mobile') || 1
                    },

                    300: {
                        slidesPerView: element.getAttribute('data-slides-mobile') || 1
                    },
                } : {},

                on: {
                    init: function() {

                    },

                    afterInit: function () {

                    },

                    activeIndexChange: function() {

                    },

                    realIndexChange: function () {

                    },

                    slideChangeTransitionEnd: function() {
                        const curSlide = this.slides[this.activeIndex];
                        if(curSlide) {
                            curVideo = curSlide.querySelector('.swiper-video');

                            if(curVideo) {
                                curVideo.currentTime = 0;
                                curVideo.play();
                            }

                            curSlide.classList.add('active');

                            const curChildren = curSlide.querySelectorAll('.aos-item');
                            curChildren.forEach(function(child) {
                                child.classList.add('aos-init', 'aos-animate');
                            });
                        }
                    },

                    slideChange: function() {
                        const lastSlide = this.slides[this.previousIndex];
                        if(lastSlide) {
                            lastVideo = lastSlide.querySelector('.swiper-video');

                            if(lastVideo) {
                                lastVideo.currentTime = 0;
                                lastVideo.pause();
                            }

                            lastSlide.classList.remove('active');

                            let allAos = lastSlide.querySelectorAll('.aos-item');
                            allAos.forEach(e => {
                                e.classList.remove('aos-init', 'aos-animate');
                            });
                        }
                    },

                    resize: function() {

                    },

                    destroy: function() {
                        // setTimeout(() => Frontend.setSwiper(), 100);
                    }
                }
            });
        });
    }
}

function toggleActiveVideo(state) {
    let activeVideo = document.querySelector('.swiper-video');
    if(activeVideo) {
        state ? activeVideo.pause() : activeVideo.play();
    }
}

document.addEventListener("DOMContentLoaded", function() {
    allSwiper.setSwiper()
});

window.addEventListener('scroll', _.throttle(function(e) {
    let top = window.pageYOffset || document.documentElement.scrollTop;
    let minscroll = top >= 100 || false;
    toggleActiveVideo(minscroll);
}, 100));
